import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿SAINT® es más rápida que la TMS convencional?",
    answer:
      "En cuanto al calendario, sí. SAINT® se completa en cinco días, mientras que la TMS convencional dura unas seis semanas. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras cinco días (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar.",
  },
];

export const esHowFastVsTms = makeEsArticle({
  slug: "how-fast-does-saint-tms-work-compared-to-tms",
  title: "¿SAINT® es más rápida que la TMS convencional?",
  description:
    "Comparación de la rapidez de SAINT® frente a la TMS convencional: calendario de cinco días frente a seis semanas para el trastorno depresivo mayor.",
  h1: "¿SAINT® es más rápida que la TMS?",
  breadcrumbLabel: "Rapidez de SAINT® vs TMS",
  shortAnswer:
    "SAINT® se completa en cinco días consecutivos; la TMS convencional suele durar unas seis semanas. En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras cinco días de SAINT® (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar y no están garantizados. Ambas están autorizadas por la FDA para el trastorno depresivo mayor; SAINT® está indicada para adultos que no han mejorado con antidepresivos.",
  keyTakeaways: [
    "SAINT® se completa en cinco días.",
    "La TMS convencional dura unas seis semanas.",
    "En los estudios de Stanford, una proporción alcanzó la remisión tras cinco días.",
    "Los resultados individuales pueden variar y no están garantizados.",
    "Ambas están autorizadas por la FDA para el trastorno depresivo mayor.",
  ],
  sections: [
    {
      heading: "Calendario de tratamiento",
      paragraphs: [
        "SAINT® administra 50 sesiones en cinco días consecutivos. La TMS convencional administra una sesión diaria, cinco días por semana, durante aproximadamente seis semanas, con un total de 30 a 36 sesiones.",
      ],
    },
    {
      heading: "Resultados en los estudios",
      paragraphs: [
        "En los estudios de Stanford, una proporción de los participantes alcanzó la remisión tras cinco días de SAINT® (Cole et al., Am J Psychiatry 2020; 2022). Los resultados individuales pueden variar y no están garantizados. La elegibilidad para SAINT® se confirma mediante una evaluación psiquiátrica.",
      ],
    },
  ],
  faqs,
  sources: [
    {
      citation:
        "Cole EJ, et al. Stanford Accelerated Intelligent Neuromodulation Therapy for Treatment-Resistant Depression. Am J Psychiatry. 2020;177(8):716-726.",
      url: "https://doi.org/10.1176/appi.ajp.2019.19070720",
    },
    {
      citation:
        "Cole EJ, et al. Stanford Neuromodulation Therapy (SNT): A Double-Blind Randomized Controlled Trial. Am J Psychiatry. 2022;179(2):132-141.",
      url: "https://doi.org/10.1176/appi.ajp.2021.20101429",
    },
  ],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
